// extracted by mini-css-extract-plugin
module.exports = {"list":"HeaderBreadcrumbs_list__1RKcn","listLi":"HeaderBreadcrumbs_listLi__CA4oA","el":"HeaderBreadcrumbs_el__2_eet","elLink":"HeaderBreadcrumbs_elLink__d6yct"};